export enum ReportImageType {
  "damage" = "damage",
  "damageDetail" = "damageDetail",
  "plate" = "plate",
  "cockpit" = "cockpit",
  "overview" = "overview",
  "registration" = "registration",
  "others" = "others"
}
